import { t as text } from "../../translations-form-miyuzyRg.js";
import { t as translations } from "../../translations-DcLD4XBj.js";
const getLocaleText = (lang, textId) => translations[lang][textId];
const getLocaleFormText = (lang, textId) => text[lang][textId];
export {
  getLocaleFormText,
  getLocaleText
};
